<template>
  <div id="app">
    <el-loading fullscreen="true" :style="{ display: isLoad ? 'block' : 'none' }" text="加载中..."></el-loading>
    <div class="rootBody">
      <div style="height: 80px; line-height: 80px; display: flex; flex-direction: column;">
        <h1 style="color: #00fbfe; letter-spacing: 10px; font-size: 40px;">水电管理数字化平台</h1>
      </div>
      <div style="flex: 1; overflow: auto; margin-top: 40px; padding-top: 70px; width: 82%;">
        <div id="containOnce" style="display: flex; width: 100%; flex-wrap: wrap; justify-content: flex-start;">
          <div v-for="(item, index) in data" :key="index" class="once" @click="isTiao(item)" @mouseenter="handleMouseEnter(item.id)" @mouseleave="handleMouseLeave(item.id)">
            <div style="display: flex; flex-direction: column; align-items: center;">
              <div class="circle-container">
                <!-- <span v-if="item.url_name !== '新增' && hoverVisit && hoverIndex === item.id" id="moreMenu" @click.stop="">
                  <el-dropdown  @command="handleCommand">
                    <span class="el-dropdown-link">
                      <i style="color: white" class="el-icon-caret-bottom el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" @mouseenter.native="cancelLeave" @mouseleave.native="handleMouseLeave">
                      <el-dropdown-item :command="'add' + item.id">新增</el-dropdown-item>
                      <el-dropdown-item :command="'edi' + item.id">编辑</el-dropdown-item>
                      <el-dropdown-item :command="'del' + item.id">删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </span> -->
                <div class="circle circle-inner">
                  <div class="icon">
                    <i v-if="item.url_name === '新增'" style="color: #00fbfe" class="el-icon-plus"></i>
                    <div v-else-if="!item.image || item.image.startsWith('el-icon')" class="avatar-text">{{ getAvatarText(item.url_name) }}</div>
                    <img v-else style="width: 100px; height: 100px;" :src="item.image" @error="imageError(item)" alt="" />
                  </div>
                </div>
                <div class="circle circle-middle"></div>
              </div>
              <span style="color: white; font-size: 20px; text-align: center; margin-top: 10px;">{{ item.url_name }}</span>
            </div>
          </div>
        </div>
      </div>

      <el-dialog :title="title" :visible.sync="dialogVisible3" :close-on-click-modal="false" @close="Clear">
        <el-form :model="form">
          <el-form-item label="名称" label-width="120px">
            <el-input v-model="form.url_name"></el-input>
          </el-form-item>
          <el-form-item label="跳转网址" label-width="120px">
            <el-input v-model="form.url"></el-input>
          </el-form-item>
          <el-form-item label="同级排序" label-width="120px">
            <el-input v-model="form.px"></el-input>
          </el-form-item>
          <el-form-item label="图标" label-width="120px">
            <div>
              <input type="file" ref="fileInput" style="display: none" accept="image/*" @change="handleImageUpload" />
              <el-button @click="$refs.fileInput.click()">选择图片</el-button>
              <img v-if="form.image" style="width: 140px; margin-left: 10px;" :src="form.image" alt="上传图标" />
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible3 = false">取 消</el-button>
          <el-button type="primary" @click="Tijiao">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="图片裁剪" :visible.sync="cropperDialogVisible" width="80%">
        <div style="height: 400px;">
          <vue-cropper
            ref="cropper"
            :img="cropperImg"
            :auto-crop="true"
            :fixed-box="true"
            :fixed="true"
            :fixed-number="[1, 1]"
            :center-box="true"
            output-type="png"
          ></vue-cropper>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cropperDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="getCroppedImage">确 定</el-button>
        </span>
      </el-dialog>

      <transition name="slide-fade">
        <div v-if="showChildren">
          <div id="diBlack1" @click="hideChildren" style="background-color: rgb(170, 166, 166); z-index: 14; opacity: 0.3; width: 100%; height: 100%; position: fixed;top: 0;left: 0;"></div>
          <div id="diBlack2" class="tanDialog">
            <div id="containOnce" style="display: flex; flex-wrap: wrap; justify-content: flex-start; width: 100%;">
              <div v-for="(item, index) in childrenData" :key="index" class="once" @click="isTiao(item)" @mouseenter="handleMouseEnter(item.id)" @mouseleave="handleMouseLeave(item.id)">
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <div class="circle-container">
                    <!-- <span v-if="hoverVisit && hoverIndex === item.id" id="moreMenu" @click.stop="">
                      <el-dropdown  @command="handleCommand">
                        <span class="el-dropdown-link">
                          <i style="color: white" class="el-icon-caret-bottom el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" @mouseenter.native="cancelLeave" @mouseleave.native="handleMouseLeave">
                          <el-dropdown-item :command="'edi' + item.id">编辑</el-dropdown-item>
                          <el-dropdown-item :command="'del' + item.id">删除</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </span> -->
                    <div class="circle circle-inner">
                      <div class="icon">
                        <div v-if="!item.image || item.image.startsWith('el-icon')" class="avatar-text">{{ getAvatarText(item.url_name) }}</div>
                        <img v-else style="width: 100px; height: 100px;" :src="item.image" @error="imageError(item)" alt="" />
                      </div>
                    </div>
                    <div class="circle circle-middle"></div>
                  </div>
                  <span style="color: white; font-size: 20px; text-align: center; margin-top: 10px;">{{ item.url_name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  computed: {
    getAvatarText() {
      return (name) => {
        if (!name) return '';
        if (name.length > 2) {
          return name.substring(0, 2);
        }
        return name;
      };
    }
  },
  data() {
    return {
      api_url: '/api',
      dataLoaded: false,
      data: [
        // {"id":2,"pid":0,"px":1,"url_name":"运营商","image":"fa fa-camera-retro","url":"https://yys.znmdhq.com","list":
        // [
        //   {"id":3,"pid":2,"px":6,"url_name":"运营商正式","image":"fa fa-plus","url":"https://yys.znmdhq.com","list":[]},
        //   {"id":4,"pid":2,"px":7,"url_name":"运营商测试","image":"fa fa-plus","url":"http://192.168.5.123:3000","list":[]},
        // ]},
        // {"id": -1,"url":"","image":"el-icon-plus","pid":0,"url_name":"新增","px":999999},
      ],
      dialogVisible3: false,
      title:'新增',
      pid: 0,
      id: 0,
      form: {
        url_name: '',
        url: '',
        image: '',
        px: '',
      },
      childrenData: [],
      hoverVisit: false,
      hoverIndex: null,
      leaveTimer: null,
      imageBase64:'',
      isLoad: false,
      refushChild: false,
      showChildren: false,
      cropperDialogVisible: false,
      cropperImg: ''
    }
  },
  mounted() {
    if (!this.dataLoaded) {
      this.get_data();
      // this.dataLoaded = true;
    }
  },
  methods: {
    async get_data() {
      this.isLoad = true;
      try {
        const response = await this.$http.get(`${this.api_url}/kbgl/get_myurl`);
        const res = response.data;
        // console.log(res);
        
        // res.DATA.push({
        //   id: -1,
        //   url: '',
        //   image: 'el-icon-plus',
        //   pid: 0,
        //   url_name: '新增',
        //   px: 999999
        // });
        if (this.refushChild) {
          let tmpData = res.DATA.find(it => it.id === this.pid);
          this.childrenData = tmpData.list;
        }
        this.data = res.DATA;
      } catch (err) {
        this.$message({
          type: 'error',
          message: err.response.data.RTN_MSG,
          duration: 5000,
          customClass: 'msgZindex'
        });
      } finally {
        this.isLoad = false;
      }
    },
    isTiao(item) {
      if (item.url_name === '新增') {
        this.dialogVisible3 = true;
        this.title = '新增';
        this.pid = 0;
      } else if (!item.list || item.list.length === 0) {
        window.open(item.url);
      } else {
        this.childrenData = item.list;
        this.showChildren = true;
      }
    },
    Clear() {
      this.form = {
        url_name: '',
        url: '',
        image: '',
        px: ''
      };
    },
    async Tijiao() {
      this.isLoad = true;
      const data = { ...this.form,
        pid: this.pid
      };
      try {
        let url = `${this.api_url}/kbgl/add_myurl`;
        if (this.title === '编辑') {
          data.id = this.id;
          url = `${this.api_url}/kbgl/up_myurl`;
        }
        const response = await this.$http.post(url, data);
        const res = response.data;
        if (res.RTN_CODE === '200') {
          this.$message({
            type: 'success',
            message: res.RTN_MSG
          });
          let tmp = false;
          if (this.pid !== 0) {
            tmp = true;
          }
          this.dialogVisible3 = false;
          this.refushChild = tmp;
          this.get_data();
          this.Clear();
        } else {
          this.$message({
            type: 'error',
            message: res.RTN_MSG
          });
        }
      } catch (err) {
        this.$message({
          type: 'error',
          message: err.response.data.RTN_MSG,
          duration: 5000,
          customClass: 'msgZindex'
        });
      } finally {
        this.isLoad = false;
      }
    },
    handleCommand(command) {
      const type = command.slice(0, 3);
      const id = parseInt(command.slice(3));
      switch (type) {
        case 'add':
          this.addChild(id);
          break;
        case 'edi':
          {
            let item = this.findItemById(this.data, id);
            this.edit(item);
            break;
          }
        case 'del':
          {
            let item1 = this.findItemById(this.data, id);
            this.del(item1);
            break;
          }
      }
    },
    findItemById(data, id) {
      for (let item of data) {
        if (item.id === id) {
          this.form = {
            url_name: item.url_name,
            url: item.url,
            image: item.image,
            px: item.px
          };
          return item;
        }
        if (item.list && item.list.length > 0) {
          let tmp = this.findItemById(item.list, id);
          if (tmp) {
            return tmp;
          }
        }
      }
    },
    addChild(item) {
      this.dialogVisible3 = true;
      this.title = '新增下级';
      this.pid = parseInt(item);
    },
    edit(item) {
      const {
        pid,
        id
      } = item;
      this.dialogVisible3 = true;
      this.title = '编辑';
      this.pid = pid;
      this.id = id;
    },
    del(item) {
      this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示（${item.url_name}）`, {
        type: 'warning'
      }).then(async () => {
        try {
          const response = await this.$http.post(`${this.api_url}/kbgl/del_myurl`, {
            id: parseInt(item.id)
          });
          const res = response.data;
          if (res.RTN_CODE === '200') {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.showChildren = false;
            this.dialogVisible3 = false;
            this.get_data();
          } else {
            this.$message({
              type: 'error',
              message: res.RTN_MSG
            });
          }
        } catch (err) {
          this.$message({
            type: 'error',
            message: err.response.data.RTN_MSG
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleMouseEnter(index) {
      this.cancelLeave();
      this.hoverVisit = true;
      this.hoverIndex = index;
    },
    handleMouseLeave() {
      this.leaveTimer = setTimeout(() => {
        this.hoverVisit = false;
        this.hoverIndex = null;
      }, 200);
    },
    cancelLeave() {
      if (this.leaveTimer) {
        clearTimeout(this.leaveTimer);
        this.leaveTimer = null;
      }
    },
    handleImageUpload(event) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        this.cropperImg = e.target.result;
        this.cropperDialogVisible = true;
      };
      reader.readAsDataURL(file);
    },
    hideChildren() {
      this.showChildren = false;
    },
    getCroppedImage() {
      this.$refs.cropper.getCropData(data => {
        this.form.image = data;
        this.cropperDialogVisible = false;
      });
    },
    imageError(item) {
      this.$set(item, 'image', 'el-icon-picture-outline');
    }
  }
}
</script>

<style>
#app {
  padding: 0px;
  margin: 0px;
}
.rootBody {
  margin: 0;
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background-image: url('@/assets/bdd-background.png');
  /* background-repeat: no-repeat; */
  background-size: cover;
  /* overflow: auto; */
}
.once {
  /* display: flex; */
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 10px;
  margin-top: 10px;
  width: 25%;
  box-sizing: border-box;
  height: auto;
}
.once:hover {
  transform: scale(1.1);
}

#moreMenu {
  width: 20px;
  height: 20px;
  color: white;
  float: right;
  z-index: 1;
  position: relative
}
#moreMenu:hover {
  transform: scale(1.2);
}

.circle-container {
  position: relative;
  width: 180px;
  height: 180px;
}

.circle {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  position: absolute;
}

.circle-inner {
  /* background: linear-gradient(45deg, #00fbfe, #00fbfe); */
  box-shadow: 3px 3px 15px #00fbfe inset;
}

.circle-middle {
  /* background: #f2f2f2; */
  z-index: -1;
}

.icon {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 60px;
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  position: relative;
  margin-top: 50%;
  transform: translateY(-50%);
}
.avatar-text {
  font-size: 40px;
  color: white;
}

.tanDialog {
  position: absolute;
  background-color: black;
  opacity: 0.85;
  top: 17%;
  left: 20%;
  width: 60%;
  height: 66%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 15;
}

.msgZindex {
  z-index: 8888;
}

/*整个滚动条样式*/
::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  /* width: 5px;
  height: 8px; */
  background-color: #fff;
}
/*定义滚动条轨道*/
::-webkit-scrollbar-track {
  background-color: #fff;
}
/*定义滑块*/
::-webkit-scrollbar-thumb {
  background-color: #ACB1BF;
  border-radius: 4px;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateY(-20px);
  opacity: 0;
}
</style>